module.exports = __webpack_public_path__ + "img/baiguullaga.f58da6e8.svg";